import React from 'react'
import ValidaNarrativa from './ValidaNarrativa'

export default function Narrativa(props) {
    
    const abreFormularioPostagens = () => {
        props.setMensagem({ tipo:'LIMPAR', texto:'' })
        ValidaNarrativa.valida(props.denuncia)
        .then( narrativa => {
            props.setDenuncia(narrativa)
            props.atuLinhaDoTempo('postagens')
        })
        .catch( msgErro => {
            props.setMensagem(msgErro)
        })
    }

    const secaoNarrativa = () => {
        const texto = (props.anonimato === "")? "complementação" : "denúncia"
        const placeholder = `Digite a ${ texto } (obrigatório)`
        return (
            <>
                <textarea
                    id="idFormDenunciaDescricao"
                    name="descricao-denuncia"
                    type="textarea"
                    className="form-control"
                    rows="5"
                    placeholder={ placeholder }
                    value={ props.denuncia }
                    onChange={ event => props.setDenuncia(event.target.value) }
                />
            </>
        )
    }

    const renderizarBotaoAnterior = () => {
        if (props.anonimato === "") {
            return <div></div>
        }

        return (
            <button 
                type="button" 
                className="btn btn-outline-primary" 
                onClick={ () => {
                    props.setMensagem({ tipo:'LIMPAR', texto:'' })
                    props.atuLinhaDoTempo('envolvidos') 
                }}
            >
                Anterior
            </button>
        )
    }

    if (!props.linhaDoTempo) {
        return null;
    }
    if (props.linhaDoTempo.emPauta !== "narrativa") {
        return null;
    }

    let titulo = "Narrativa da "
    titulo += (props.anonimato === "")? "complementação:" : "ocorrência:" 
    return (
        <>
            <fieldset className="border p-3 mt-4">
                <legend className="row w-auto">
                    <h4 className="ml-3">
                        <small>
                            { titulo }
                        </small>
                    </h4> 
                </legend>
                { secaoNarrativa() }
                <div className="mt-4">
                    <div className="d-flex justify-content-between">
                        { renderizarBotaoAnterior() }
                        <button 
                            type="button" 
                            className="btn btn-outline-primary " 
                            onClick={ abreFormularioPostagens }
                        >
                            Próximo
                        </button>
                    </div>
                </div>
            </fieldset>
        </>
    )
}